import { useQuery } from '@tanstack/react-query'
import { tenMinutes } from 'src/constants/constants'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'
import { IArchivedDocument } from './types'

export function useGetVesselArchivedDocuments(vesselId: string | undefined) {
  const fetchRequest = useFetch<IArchivedDocument[]>()

  const url = `/vessels/${vesselId}/documents/bloblist`

  return useQuery({
    queryKey: [url],
    queryFn: () => fetchRequest(`${apiBase()}${url}`),
    staleTime: tenMinutes,
    enabled: false,
  })
}
